import React from 'react';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import { createStructuredSelector } from 'reselect';
import loadable from '@signal/hoc/loadable';
import combinedError from '@signal/hoc/combinedError';
import AccountPickerSkeleton from '@signal/components/AccountPicker/skeleton';
import ErrorScreenApi from '../ErrorScreenApi';
export var getAccountPicker = function getAccountPicker(Skeleton) {
  return loadable({
    loader: function loader() {
      return import(
      /* webpackChunkName: "container-account-picker" */
      './component');
    },
    dataLoader: function dataLoader() {
      return import(
      /* webpackChunkName: "lib-user" */
      '@signal/core/user');
    },
    loadData: function loadData(_ref, loaderInterface) {
      var userDetailsLoader = _ref.userDetailsLoader,
          userAccountsLoader = _ref.userAccountsLoader;
      return Promise.all([userDetailsLoader(loaderInterface), userAccountsLoader(loaderInterface)]);
    },
    loading: Skeleton,
    error: combinedError(ErrorScreenApi)
  });
};
export function getConnectedAccountPicker(backPathSelector, initialPathSelector, pickerProps) {
  var AccountPicker = getAccountPicker(function () {
    return /*#__PURE__*/React.createElement(AccountPickerSkeleton, pickerProps);
  });

  function AccountPickerWithRedirect(_ref2) {
    var push = _ref2.push,
        backPath = _ref2.backPath,
        initialPath = _ref2.initialPath;

    var handleRedirect = function handleRedirect(activeAccount, prevAccount) {
      if (prevAccount !== activeAccount) {
        push(prevAccount ? backPath : initialPath);
      }
    };

    return /*#__PURE__*/React.createElement(AccountPicker, Object.assign({
      onUpdateAccount: handleRedirect
    }, pickerProps));
  }

  var mapStateToProps = createStructuredSelector({
    backPath: backPathSelector,
    initialPath: initialPathSelector
  });
  var mapDispatchToProps = {
    push: push
  };
  return connect(mapStateToProps, mapDispatchToProps)(AccountPickerWithRedirect);
}
export default getAccountPicker(AccountPickerSkeleton);